<div [ngStyle]="{'height': 'inherit', 'display':'flex', 'flex-direction':'column'}">
  <div class="dx-fieldset" [ngStyle]="{'margin': '20px 30px'}">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Medien Felder auswählen' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.mimeContentFilter.useFilter" (onValueChanged)="refreshMimeSelectFilter()"></dx-switch>
      </div>
    </div>
  </div>
  <div *ngIf="exportParameter.mimeContentFilter.useFilter" [ngStyle]="{'height': '100%', 'overflow':'hidden'}">
    <div *ngIf="isFilterLoaded==false" style="top: 30%;">
      <div class="loader">
      </div>
    </div>
    <div *ngIf="isFilterLoaded==true" class="{{fullScreen ? '' : 'maxHeight'}}" [ngStyle]="{'margin-top': '-20px', 'height': 'inherit'}">
      <dx-tree-list [(dataSource)]="mimeSelectFilters"
                    [(selectedRowKeys)]="exportParameter.mimeContentFilter.filterKey"
                    dataStructure="tree"
                    keyExpr="description"
                    showCheckBoxesMode="selectAll"
                    [ngStyle]="{'height': 'inherit'}">
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="multiple" recursive="true"></dxo-selection>
        <dxo-scrolling preloadEnabled="true" useNative="true"></dxo-scrolling>
        <dxi-column dataField="description" caption="{{ 'Beschreibung' | translate }}"></dxi-column>
      </dx-tree-list>
    </div>
  </div>
</div>
